<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
	<path
		d="M2.99988 9.5V15.5C2.99988 15.8978 3.15791 16.2794 3.43922 16.5607C3.72052 16.842 4.10205 17 4.49988 17H13.4999C13.8977 17 14.2792 16.842 14.5605 16.5607C14.8418 16.2794 14.9999 15.8978 14.9999 15.5V9.5"
		stroke="white"
		stroke-width="1.5"
		stroke-linecap="round"
		stroke-linejoin="round"
	/>
	<path
		d="M11.9999 5L8.99988 2L5.99988 5"
		stroke="white"
		stroke-width="1.5"
		stroke-linecap="round"
		stroke-linejoin="round"
	/>
	<path
		d="M8.99988 2V11.75"
		stroke="white"
		stroke-width="1.5"
		stroke-linecap="round"
		stroke-linejoin="round"
	/>
</svg>
